var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-apex-charts',{attrs:{"type":"heatmap","height":"300","options":_vm.config,"series":_vm.data}})}
var staticRenderFns = []

export { render, staticRenderFns }